import { FormattedMessage } from 'react-intl';

import { messages } from '../product-grid/messages';
import styles from './styles.module.less';

type ProductGridFooterProps = {
  totalProducts: number;
};

export const ProductGridFooter = ({ totalProducts }: ProductGridFooterProps) => (
  <div className={styles['product-grid-footer']}>
    <FormattedMessage
      {...messages.showingProductSummary}
      values={{
        start: totalProducts > 0 ? 1 : 0,
        end: totalProducts,
        total: totalProducts,
        b: (chunks: React.ReactNode) => <b>{chunks}</b>,
      }}
    />
  </div>
);
